<template>
  <div :class="$style.base">
    <CustomerAlert
      v-if="showNewCustomersAlert"
      :customAlert="settings.custom_customer_stop_message"
      @onCloseClick="showNewCustomersAlert = false"
    />
    <CustomerAlert
      v-if="showCustomAlert"
      :customAlert="customAlert"
      @onCloseClick="showCustomAlert = false"
    />
  </div>
</template>

<script setup lang="ts">
import CustomerAlert from '@/components/CustomerAlert.vue';
import { useCompanyStore } from '@/stores/company';
import { useBookingStore } from '@/stores/booking';
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
const { settings } = useCompanyStore();

const showNewCustomersAlert = ref(!settings.allow_new_customers);
const { employeeId } = storeToRefs(useBookingStore());

watch(
  employeeId,
  () => {
    if (settings.existing_customers_resource_ids?.length) {
      showNewCustomersAlert.value =
        settings.existing_customers_resource_ids.includes(employeeId.value);
    }
  },
  {
    immediate: true
  }
);

const customAlert = ref(settings.custom_alert);
const showCustomAlert = ref(!!customAlert.value);
</script>

<style lang="scss" module>
.base {
  & > *:not(:last-child) {
    margin-bottom: 1px;
  }
}
</style>
